import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@Component({
  selector: 'app-document-link',
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './document-link.component.html',
  styles: [
    `
      :host {
        // border: 1px solid blue;
        display: flex;
        flex: 1;
        line-height: 32px;
        align-items: center;

        .document-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 120px;
          /*width: 0;
          min-width: 120px;
          flex-grow: 1;
          padding-right: 10px;
          margin-left: 10px; */
          display: flex;
          align-items: center;
        }

        .document-extension {
          padding-right: 10px;
          min-width: 40px;
        }

        .modified-date {
          min-width: 80px;
          text-align: right;
        }

        mat-icon {
          transform: scale(0.9);
        }
      }
    `,
  ],
})
export class DocumentLinkComponent {
  @Input({ required: true }) title: string;
  @Output() onclick = new EventEmitter();
}
